export const Charts_Container_Elements = {
    Charts_Container: "charts-container",
    Chart_Body: "chart-body",
    Chart_Layout_Single_Button: "chart-layout-single-button",
    Chart_Layout_Dual_Button: "chart-layout-dual-button",
    Extruder_Selector: "extruder-selector",
    Supported_Resins_Modal: "supported-resins-modal"
};
